import { makeAutoObservable } from 'mobx';
import { getUserDataFromAccessToken } from 'shared';

export interface IUserContext {
	isLogged: boolean;
	userId: string | null;
	userLogin: string | null;
	userName: string | null;
	userRole: string;
	userWorkplaceId: string | null;
	userWorkplaceName: string | null;
}

class UserStore {
	userContext: IUserContext = {
		isLogged: false,
		userId: null,
		userLogin: null,
		userName: null,
		userRole: '',
		userWorkplaceId: null,
		userWorkplaceName: null,
	};

	constructor() {
		makeAutoObservable(this);
		this.loadUserContext();
	}

	setUserContext(tokenData: any) {
		if (tokenData)
			this.userContext = {
				isLogged: tokenData.id != null,
				userId: tokenData.id,
				userName: tokenData.name,
				userLogin: tokenData.userName,
				userRole: tokenData.roles,
				userWorkplaceId: tokenData.userWorkplaceId,
				userWorkplaceName: tokenData.userWorkplaceName,
			};
	}

	clearUserContext() {
		this.userContext = {
			isLogged: false,
			userId: null,
			userLogin: null,
			userName: null,
			userRole: '',
			userWorkplaceId: null,
			userWorkplaceName: null,
		};
	}

	loadUserContext() {
		const tokenData = getUserDataFromAccessToken()
		if (tokenData) {
			this.setUserContext(tokenData)
		}
		else this.clearUserContext()
	}
}

export const userStore = new UserStore();
